import moment, { defaultFormat } from "moment";

export function humanizeDate(dateString) {
    return moment(dateString, 'YYYY-MM-DD HH:mm:ss').format('D MMM, YYYY')
}
export function humanizeTime(dateString, defaultFormat = 'HH:mm:ss') {
    return moment(dateString, defaultFormat).format('H:mm ')
}
export function humanizeTimeFromDatetime(dateString) {
    return moment(dateString, 'YYYY-MM-DD HH:mm:ss').format('H:mm ')
}
export function humanizeRelativeFromDate(dateString, defaultFormat = 'YYYY-MM-DD HH:mm:ss') {
    return moment(dateString, defaultFormat).fromNow()
}
export function humanizeRelativeToDate(dateString, defaultFormat = 'YYYY-MM-DD HH:mm:ss') {
    return moment(dateString, defaultFormat).toNow()
}
export function humanizeDateTime(dateString) {
    return moment(dateString, 'YYYY-MM-DD HH:mm:ss').format('H:mm @ D MMM, YYYY')
}
export function humanizeCurrency(value) {
    return 'Rp. ' + humanizeNumber(value, 0, 0)
}
export function humanizeNumber(value, maximumFractionDigits = 2, minimumFractionDigits = 2) {
    return parseFloat(value).toLocaleString('id-ID', { maximumFractionDigits, minimumFractionDigits })
}
export function humanizePercentage(value, precision = 0) {
    return (value * 100.0).toFixed(precision) + '%'
}
export function humanizeDuration(start, end) {
    return moment.duration(moment(end, 'HH:mm:ss').diff(moment(start, 'HH:mm:ss')))
}